import { useState, useEffect } from 'react'
import { Users, Building2, Activity, Database } from 'lucide-react'

interface OverviewData {
  totalUsers: number
  activeUsers: number
  totalBusinesses: number
  totalSimulations: number
}

export function AdminOverviewPage() {
  const [data, setData] = useState<OverviewData | null>(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    fetch('/api/admin/overview')
      .then(res => res.json())
      .then((json: any) => {
        if (json.success) setData(json.data)
        setLoading(false)
      })
      .catch(() => setLoading(false))
  }, [])

  if (loading) return <div className="animate-pulse flex space-x-4"><div className="h-4 bg-slate-800 rounded w-1/4"></div></div>

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-slate-100">Platform Overview</h1>
        <p className="text-sm text-slate-400 mt-1">Global metrics for UMKM Business Cockpit.</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        <MetricCard title="Total Users" value={data?.totalUsers || 0} icon={Users} color="text-blue-400" />
        <MetricCard title="Active Users" value={data?.activeUsers || 0} icon={Activity} color="text-emerald-400" />
        <MetricCard title="Total Businesses" value={data?.totalBusinesses || 0} icon={Building2} color="text-indigo-400" />
        <MetricCard title="Simulations Run" value={data?.totalSimulations || 0} icon={Database} color="text-purple-400" />
      </div>
      
      <div className="bg-slate-900 border border-slate-800 rounded-xl p-6 mt-8">
        <h2 className="text-lg font-semibold text-slate-200 mb-4">System Health</h2>
        <div className="flex items-center gap-4">
          <div className="w-3 h-3 rounded-full bg-emerald-500 animate-pulse"></div>
          <p className="text-sm text-slate-300">All systems operational. D1 and R2 bindings are connected.</p>
        </div>
      </div>
    </div>
  )
}

function MetricCard({ title, value, icon: Icon, color }: any) {
  return (
    <div className="bg-slate-900 border border-slate-800 p-6 rounded-xl shadow-sm flex items-start justify-between">
      <div>
        <p className="text-sm font-medium text-slate-400">{title}</p>
        <p className={`text-3xl font-bold mt-2 ${color}`}>{value}</p>
      </div>
      <div className="p-3 bg-slate-800 rounded-lg">
        <Icon size={24} className={color} />
      </div>
    </div>
  )
}
